import Container from "Components/Container/Container";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ShareNetwork } from "@phosphor-icons/react";
import Spinner from "Components/RequestHandler/Spinner";

const Landing = ({ data, slug }) => {
  const fileInputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadDone, setUploadDone] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);

  const handleUploadCv = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("upload_cv", file);

    try {
      setIsLoading(true);
      const response = await fetch(
        `https://www.martinpro-me.com/api/career/upload-cv/${slug}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        setUploadDone(true);
        setTimeout(() => setUploadDone(false), 3000); // Reset state after 2 seconds
      } else {
        setUploadFailed(true);
        setTimeout(() => setUploadFailed(false), 3000); // Reset state after 2 seconds
        const errorData = await response.json();
        console.error("Error uploading CV:", errorData);
      }
    } catch (error) {
      setUploadFailed(true);
      setTimeout(() => setUploadFailed(false), 2000); // Reset state after 2 seconds
      console.error("Error uploading CV:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShare = async () => {
    const message = `Check out this amazing job opportunity: ${data?.job_title}\n\nApply here: ${window.location.origin}/careers_job_details/${slug}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: data?.job_title || "Job Opportunity",
          text: message,
          url: `${window.location.origin}/careers_job_details/${slug}`,
        });
      } catch (error) {
        console.error("Error sharing job:", error);
      }
    } else {
      alert("Sharing is not supported on this device.");
    }
  };

  return (
    <section className="pb-secondary scroll-section-special">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-24">
          <div className="text-white mb-16 col-span-2">
            <p className="text-lg">{data?.date}</p>
            <p className="bebas text-6xl">{data?.job_title}</p>
            <div
              className="mt-16 custom-content"
              dangerouslySetInnerHTML={{ __html: data.job_description }}
            />

            <div
              className={`${
                isLoading
                  ? "bg-[#222]"
                  : uploadDone
                  ? "bg-green-400"
                  : uploadFailed
                  ? "bg-red-400"
                  : "bg-[#222]"
              } flex flex-col lg:flex-row items-center gap-4 px-8 mt-32 py-4`}
            >
              {isLoading ? (
                <div className="w-full flex items-center justify-center">
                  <Spinner />
                </div>
              ) : (
                <button
                  className="text-white lg:w-3/4 text-2xl uppercase"
                  onClick={handleUploadCv}
                >
                  {uploadDone
                    ? "CV uploaded successfully"
                    : uploadFailed
                    ? "Upload failed, try again"
                    : "Upload CV"}
                </button>
              )}
              <input
                type="file"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx"
              />
              <button
                className="flex items-center uppercase text-lg gap-x-2 text-[#999] lg:justify-end lg:w-1/4 lg:ml-auto"
                onClick={handleShare}
              >
                Share
                <span className="bg-[#999] rounded-full text-black p-1 text-2xl">
                  <ShareNetwork weight="fill" />
                </span>
              </button>
            </div>
          </div>

          <div className="col-span-1 h-auto sticky top-0">
            <div className="sticky top-[10vh]">
              <p className="text-font uppercase text-4xl mb-6">Current Jobs</p>
              <div className="bg-[#222] flex flex-col gap-y-6 text-white px-6 py-8">
                {data?.other_jobs.map(({ date, job_title, slug }, index) => (
                  <Link
                    className="group"
                    to={`/carrers_job_details/${slug}`}
                    key={index}
                  >
                    <p>{date}</p>
                    <p className="text-2xl group-hover:underline capitalize">
                      {job_title}
                    </p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Landing;
